import { Dispatch } from 'redux';
import axios from '../../config/Axios/axios-instance';
import {
  sendFbPixelEventFail,
  sendFbPixelEventStart,
  sendFbPixelEventSuccess,
} from './action';

const API_URL = '/fb-pixel';

export enum FbPixelEventName {
  // eslint-disable-next-line no-unused-vars
  VIEW_CONTENT = 'ViewContent',
  // eslint-disable-next-line no-unused-vars
  CONTACT = 'Contact',
  // eslint-disable-next-line no-unused-vars
  INITIATE_CHECKOUT = 'InitiateCheckout',
  // eslint-disable-next-line no-unused-vars
  COMPLETE_REGISTRATION = 'CompleteRegistration',
  // eslint-disable-next-line no-unused-vars
  PURCHASE = 'Purchase',
  // eslint-disable-next-line no-unused-vars
  PURCHASE_FIRST_SESSION = 'purchase_first_session',
  // eslint-disable-next-line no-unused-vars
  PURCHASE_MEMBERSHIP = 'purchase_membership',
}

export type SendFbPixelEvent = {
  eventName: FbPixelEventName;
  purchaseValue?: number | string;
  fbc?: string;
  eventId: string;
};

export const sendFbPixelEvent =
  (inputs: SendFbPixelEvent, isAuthorized: boolean) => (dispatch: Dispatch) => {
    dispatch(sendFbPixelEventStart());

    return axios
      .post(isAuthorized ? `${API_URL}/authorized` : API_URL, inputs)
      .then(() => {
        dispatch(sendFbPixelEventSuccess());
      })
      .catch((err) => {
        dispatch(sendFbPixelEventFail(err?.response?.data?.error));
      });
  };
